export const fetchBrowserPhoneBootstrap = async accountId => {
  const response = await window.axios.get(
    `/api/v1/accounts/${accountId}/browser_phone/bootstrap`
  );

  return response.data;
};
